module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/4/3-500e81e0b5b9e09003ac40f7ef41b7b8.jpg";